<span
  class="color-primary"
  [ngClass]="[ currentItem?.isNumber ? 'lb-counter-item--number color-light' : 'lb-counter-item--separator color-light' ,
    minSize === true ? 'small':'']"
>
  {{ currentItem?.item }}
</span>
